import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export interface FolyamatlapTetelDto {
  datum: string;
  tipus: string;
  targy: string;
  nev: string;
  munkaszam: string;
  iktatasIranya?: string | null;
  idoraforditasOra?: number | null;
}

class FolyamatlapService {
  async getByMunkaszam(munkaszam: string): Promise<FolyamatlapTetelDto[]> {
    const response = await api.get<FolyamatlapTetelDto[]>(
      `/munkaszamok/${encodeURIComponent(munkaszam)}/folyamatlap`
    );

    return response.data;
  }
}

export const folyamatlapService = new FolyamatlapService();
